<nav
  class="px-0 px-lg-5"
  [ngClass]="
    isLandingPage && showNavbarBackground
      ? 'scroll'
      : isLandingPage && !showNavbarBackground
      ? 'nav-transparent'
      : !isLandingPage && showNavbarBackground
      ? 'scroll'
      : 'nav-opaque'
  "
>
  <div class="mt-3" style="flex: 0.45">
    <img
      style="cursor: pointer"
      routerLink="/home"
      [src]="
        isLandingPage ? '/assets/img/Logo.svg' : '/assets/img/Logo-dark.svg'
      "
      class="ml-3 ml-lg-0 mt-3 mt-lg-0"
      alt="Logo Image"
    />
  </div>
  <div (click)="toggleHamburger()" class="hamburger" #hamburger>
    <div [ngClass]="isLandingPage ? 'bg-light' : 'bg-dark'" class="line1"></div>
    <div [ngClass]="isLandingPage ? 'bg-light' : 'bg-dark'" class="line2"></div>
    <div [ngClass]="isLandingPage ? 'bg-light' : 'bg-dark'" class="line3"></div>
  </div>
  <div class="nav-links-wrapper" #navLinksWrapper style="flex: 0.75">
    <ul class="nav-links">
      <li [ngClass]="{ active: router.url == '/home' }" #navLink>
        <a
          class="mr-0 mr-lg-5"
          [ngClass]="
            isLandingPage && showNavbarBackground
              ? 'text-light'
              : !isLandingPage && !showNavbarBackground
              ? 'text-dark'
              : !isLandingPage && showNavbarBackground
              ? 'text-light'
              : 'text-light'
          "
          style="cursor: pointer"
          routerLink="/home"
          (click)="checkhamburger()"
          >Home</a
        >
      </li>
      <li #navLink>
        <a
          class="mr-0 mr-lg-5"
          [ngClass]="
            isLandingPage && showNavbarBackground
              ? 'text-light'
              : !isLandingPage && !showNavbarBackground
              ? 'text-dark'
              : !isLandingPage && showNavbarBackground
              ? 'text-light'
              : 'text-light'
          "
          style="cursor: pointer"
          (click)="openGuestAccessModal()"
          >Login As Guest</a
        >
      </li>
      <li #navLink>
        <a
          class="mr-0 mr-lg-5"
          [ngClass]="
            isLandingPage && showNavbarBackground
              ? 'text-light'
              : !isLandingPage && !showNavbarBackground
              ? 'text-dark'
              : !isLandingPage && showNavbarBackground
              ? 'text-light'
              : 'text-light'
          "
          style="cursor: pointer"
          routerLink="/event/feeds"
          (click)="checkhamburger()"
          >Social Feed</a
        >
      </li>
      <li #navLink>
        <a
          class="mr-0 mr-lg-5"
          [ngClass]="
            isLandingPage && showNavbarBackground
              ? 'text-light'
              : !isLandingPage && !showNavbarBackground
              ? 'text-dark'
              : !isLandingPage && showNavbarBackground
              ? 'text-light'
              : 'text-light'
          "
          routerLink="/event/explore"
          style="cursor: pointer"
          (click)="checkhamburger()"
          >Explore events</a
        >
      </li>
    </ul>
    <ul class="nav-links">
      <li #navLink>
        <button
          type="button"
          routerLink="/auth/login"
          class="btn py-3 px-5"
          [ngClass]="isLandingPage ? 'btn-inverted' : 'btn-custom'"
        >
          Login
        </button>
      </li>
    </ul>
  </div>
</nav>
<app-guest-access *ngIf="openAccessModal"></app-guest-access>
